import { Button, Select } from "antd";
import Input from "antd/lib/input/Input";
import { useHistory } from "react-router-dom";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { Locale } from "../../../utils";
import { getList } from "../../../utils/http/dataProvider";
import { getUserInfo } from "../../../utils/redux/reducers/User";
import {
  typeLabels,
  TYPE_ARTICLE,
  TYPE_AUDIO,
  TYPE_VIDEO,
} from "./courseTypes";

const i18n = Locale.getInstance();
const { Option } = Select;

const CourseListHeader = ({
  keyword,
  setKeyword,
  type,
  categoryId,
  setCategoryId,
  notForSaleFilter,
  setNotForSaleFilter,
}) => {
  const router = useHistory();
  const user = useSelector((state) => getUserInfo(state));
  
  let addLabel = i18n.t("course.add");
  if (type === TYPE_ARTICLE) {
    addLabel = i18n.t("course.addArticle");
  }
  if (type === TYPE_AUDIO) {
    addLabel = i18n.t("course.addAudio");
  }
  if (type === TYPE_VIDEO) {
    addLabel = i18n.t("course.addVideo");
  }

  const { data: categoriesData } = useQuery(
    ["course-categories", user.token],
    () =>
      getList("course/categories", {
        pagination: {
          perPage: 1000,
          page: 1,
        },
        sort: {
          field: "id",
          order: "desc",
        },
        token: user.token,
      })
  );

  const flattenCategories = (categories, result = []) => {
    if (!categories) return result;
    categories.forEach((cat) => {
      result.push(cat);
      if (cat.sub_categories && cat.sub_categories.length > 0) {
        flattenCategories(cat.sub_categories, result);
      }
    });
    return result;
  };

  const categories = categoriesData?.data ? flattenCategories(categoriesData.data) : [];

  return (
    <div className="header">
      <div className="actions">
        <Button
          onClick={() => {
            router.push({
              pathname: `/main/courses/${typeLabels[type]}-courses/edit`,
              state: {
                type,
              },
            });
          }}
          type="primary"
        >
          {addLabel}
        </Button>
      </div>
      <div className="search">
        <Select
          style={{ width: 200, marginRight: 8 }}
          placeholder={i18n.t("course.selectCategory")}
          allowClear
          value={categoryId === 0 ? undefined : categoryId}
          onChange={(value) => setCategoryId(value || 0)}
        >
          {categories.map((cat) => (
            <Option key={cat.id} value={cat.id}>
              {i18n.getPropNameByLocale(cat, "name")}
            </Option>
          ))}
        </Select>
        <Select
          style={{ width: 160, marginRight: 8 }}
          placeholder={i18n.t("course.saleTypeFilter")}
          allowClear
          value={notForSaleFilter}
          onChange={(value) => setNotForSaleFilter(value)}
        >
          <Option value={0}>{i18n.t("course.forSale")}</Option>
          <Option value={1}>{i18n.t("course.notForSale")}</Option>
        </Select>
        <Input
          defaultValue={keyword}
          onChange={(e) => {
            setKeyword(e.target.value);
          }}
          placeholder={i18n.t("course.name")}
          style={{ width: 200, marginRight: 8 }}
        />
        <Button type="primary">{i18n.t("common.search")}</Button>
      </div>
    </div>
  );
};
export default CourseListHeader;
